var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import moment from 'moment';
import YearSelect from './YearSelect';
export var MonthYearPickerOutputFormat;
(function (MonthYearPickerOutputFormat) {
    MonthYearPickerOutputFormat["moment"] = "moment";
    MonthYearPickerOutputFormat["date"] = "date";
    MonthYearPickerOutputFormat["object"] = "object";
})(MonthYearPickerOutputFormat || (MonthYearPickerOutputFormat = {}));
export var MonthYearPickerMonthFormat;
(function (MonthYearPickerMonthFormat) {
    MonthYearPickerMonthFormat["M"] = "M";
    MonthYearPickerMonthFormat["MM"] = "MM";
    MonthYearPickerMonthFormat["MMM"] = "MMM";
    MonthYearPickerMonthFormat["MMMM"] = "MMMM";
})(MonthYearPickerMonthFormat || (MonthYearPickerMonthFormat = {}));
var parseValue = function (value) {
    if (value === null || value === undefined)
        return { year: null, month: 0 };
    if (value instanceof Date)
        return { year: value.getFullYear(), month: value.getMonth() };
    if (moment.isMoment(value))
        return { year: value.year(), month: value.month() };
    if (typeof value.year === 'number' && typeof value.month === 'number')
        return { year: value.year, month: value.month };
    return { year: null, month: 0 };
};
export var displayDayMonth = function (value, monthFormat) {
    if (monthFormat === void 0) { monthFormat = 'MMMM'; }
    var date = parseValue(value);
    return moment({ year: date.year, month: date.month, day: 1 }).format("".concat(monthFormat, " YYYY"));
};
var MonthYearPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.outputType, outputType = _b === void 0 ? MonthYearPickerOutputFormat.object : _b, _c = _a.monthFormat, monthFormat = _c === void 0 ? MonthYearPickerMonthFormat.MMMM : _c, _d = _a.onBlur, onBlur = _d === void 0 ? function () { } : _d, _e = _a.onKeyDown, onKeyDown = _e === void 0 ? function () { } : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, yearsInPast = _a.yearsInPast, yearsInFuture = _a.yearsInFuture;
    var _g = useState(parseValue(value)), innerValue = _g[0], setInnerValue = _g[1];
    useEffect(function () {
        var _a = parseValue(innerValue), oldYear = _a.year, oldMonth = _a.month;
        var newValue = parseValue(value);
        var newYear = newValue.year, newMonth = newValue.month;
        if (oldYear !== newYear || oldMonth !== newMonth) {
            setInnerValue(newValue);
        }
    }, [value]);
    var submitValue = function (force) {
        if (force === void 0) { force = false; }
        var year = innerValue.year, month = innerValue.month;
        var oldValue = parseValue(value);
        if (Number.isNaN(year) || year === null) {
            if (force || value)
                onChange(null);
            return;
        }
        if (!force) {
            if (oldValue.year === year && oldValue.month === month)
                return;
        }
        if (outputType === 'object')
            onChange(__assign({}, innerValue));
        else if (outputType === 'date')
            onChange(new Date(year, month, 1));
        else if (outputType === 'moment')
            onChange(moment.utc({ year: year, month: month, day: 1 }));
    };
    useEffect(function () {
        submitValue();
    }, [innerValue]);
    var monthOptions = useMemo(function () {
        var m = [];
        for (var i = 0; i < 12; i += 1)
            m.push(_jsx("option", __assign({ value: i }, { children: moment({ year: 2000, month: i, day: 1 }).format(monthFormat) }), i));
        return m;
    }, [monthFormat]);
    var handleOutsideClick = function () {
        submitValue();
        onBlur();
    };
    var changeYear = function (year) {
        setInnerValue(function (oldValue) { return (__assign(__assign({}, oldValue), { year: year })); });
        submitValue();
    };
    var changeMonth = function (e) {
        var month = parseInt(e.target.value, 10) || 0;
        setInnerValue(function (oldValue) { return (__assign(__assign({}, oldValue), { month: month })); });
        submitValue();
    };
    return (_jsx(OutsideClickHandler, __assign({ onOutsideClick: handleOutsideClick }, { children: _jsxs("div", __assign({ className: "react-month-year-picker input-group horizontal-form" }, { children: [_jsx("select", __assign({ value: innerValue.month, className: "form-control month-input", onChange: changeMonth, onKeyDown: onKeyDown, disabled: disabled, name: "month" }, { children: monthOptions })), _jsx(YearSelect, { value: innerValue.year, onChange: changeYear, yearsInPast: yearsInPast, yearsInFuture: yearsInFuture, onKeyDown: onKeyDown, disabled: disabled, required: true, name: "year", className: "form-control year-input" })] })) })));
};
export default MonthYearPicker;
